import React from 'react';
import { useRouter } from 'next/router';
import { toast } from 'react-toastify';
import posthog from 'posthog-js';
import * as Sentry from '@sentry/nextjs';
import { Button } from '../../commons';
import { DoneIcon } from '../../icons';
import { useApplication } from '../../../hooks';
import { generateDocumentDefinition } from '../../../lib';

export default function EleventhStep() {
  const router = useRouter();
  const [application] = useApplication();
  const onClickDownload = async (e: React.MouseEvent<HTMLButtonElement>) => {
    try {
      e.preventDefault();
      const { default: pdfmake } = await import('pdfmake/build/pdfmake');
      const { default: vfs } = await import('pdfmake/build/vfs_fonts');
      pdfmake.addVirtualFileSystem(vfs);
      pdfmake
        .createPdf(generateDocumentDefinition(application))
        .download(`application-${application?.id}.pdf`);
    } catch (err) {
      posthog?.captureException(err);
      Sentry.captureException(err, {
        level: 'fatal',
        user: {
          email: application.applicant.email,
        },
      });
      toast.error(err.message, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  const onClickPrint = async (e: React.MouseEvent<HTMLButtonElement>) => {
    try {
      e.preventDefault();
      const { default: pdfmake } = await import('pdfmake/build/pdfmake');
      const { default: vfs } = await import('pdfmake/build/vfs_fonts');
      pdfmake.addVirtualFileSystem(vfs);
      pdfmake.createPdf(generateDocumentDefinition(application)).print();
    } catch (err) {
      posthog?.captureException(err);
      Sentry.captureException(err, {
        level: 'fatal',
        user: {
          email: application.applicant.email,
        },
      });
      toast.error(err.message, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  return (
    <div className="py-20 px-32 flex justify-center items-center">
      <div className="w-full m-auto flex flex-col">
        <div className="w-full flex flex-col ">
          <div className="w-16 h-16 rounded-full bg-green border border-[#0D9A00] flex mx-auto">
            <DoneIcon className="m-auto text-white w-12 h-12" />
          </div>
          <h2 className="text-4xl text-neutral-600 text-center mt-12">
            Form Successfully Submitted
          </h2>
          <Button
            type="button"
            color="blue"
            className="my-4 mx-auto w-full max-w-[288px]"
            onClick={onClickDownload}
          >
            Download Application
          </Button>
          <Button
            type="button"
            color="green"
            className="text-white mx-auto mb-4 w-full max-w-[288px]"
            onClick={onClickPrint}
          >
            Print Application
          </Button>
          <Button
            type="button"
            color="magenta"
            className="mx-auto mb-4 w-full max-w-[288px]"
            onClick={async (e) => {
              e.preventDefault();
              await router.push('/');
            }}
          >
            Go Back Home
          </Button>
        </div>
      </div>
    </div>
  );
}
